// extracted by mini-css-extract-plugin
export default {"container":"jAVXB0","contentContainer":"vOWT44"};